module.exports = __webpack_public_path__ + "static/media/stake-bj.52824981.svg";